import './viewRegistration.css';
import { Component } from 'react';

import * as appActions from '../../actions/appActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Samy } from 'react-samy-svg';
import { deviceColors, Credentials, ApiActions } from '../../helpers/constants';
import { checkUserExists, userRegistration } from '../../helpers/helperApi';
import { openNotificationWithIcon } from '../../helpers/funcs';

import logo from '../../images/other/vku_logo.svg';

import Cookies from 'js-cookie';

class ViewRegistration extends Component {
    constructor(props){
        super(props);

        this.login = this.login.bind(this);

        this.state = {
            login: "",
            password: "",
            changed: false
        }
    }

    async login(event) {
        let owner = this;
        let local = this.props.appState.local;

        if (!this.state.login || !this.state.password){
            openNotificationWithIcon("info", 
                local.AuthMessageTitle, local.RegistrationLoginIncorrect + ". " + local.RegistrationPasswordEmpty);
            return;
        }
        let result = await checkUserExists(this.state.login, ApiActions.Get);
        if (result === true){
            openNotificationWithIcon('error', local.appTitle, local.RegistrationLoginExists);
            return;
        }

        result = await userRegistration(this.state.login, this.state.password, ApiActions.Post);
        if (result === true){
            openNotificationWithIcon('info', local.appTitle, local.RegistrationWaitConfirm);
        } else {
            openNotificationWithIcon('error', local.appTitle, local.RegistrationError);
        }
        
        Credentials.login = this.state.login;
        Credentials.password = this.state.password;
        Cookies.set('autoEnter', true);
        owner.props.close();
    }
    
    render() {
        var local = this.props.appState.local;
        var isDarkTheme = this.props.appState.isDarkTheme;

        return (
            <div className="ViewRegistration Credentials">
                <div className='ViewLogin__logo'>
                    <Samy path={logo} />
                </div>
                {/* <div className="LoginAppTitle">{local.appTitle}</div> */}
                {/* <p>{local.AuthReg}</p> */}
                <input
                    autoComplete='off'
                    value={this.state.login}
                    onChange={(e)=> this.setState({login: e.target.value, changed: true})}
                    style={{margin: "10px 0px", height:"45px"}}
                    placeholder={local.AuthLogin}
                    type="email"
                />
                <input
                    autoComplete='off'
                    value={this.state.password}
                    onChange={(e)=> this.setState({password: e.target.value, changed: true})}
                    style={{margin: "10px 0px", height:"45px"}}
                    placeholder={local.AuthPassword}
                    type="password"
                />
                <div className='Credentials__buttons'>
                    <button onClick={(event) => this.login(event)}>
                        {local.AuthReg}
                    </button>
                    <button onClick={this.props.close}>
                        {local.Back}
                    </button>
                </div>
            </div>
        );
  }
}

function mapStateToProps(state) { return { appState: state.appState } }
function mapDispatchToProps(dispatch) { return { appActions: bindActionCreators(appActions, dispatch) } }
export default connect(mapStateToProps, mapDispatchToProps)(ViewRegistration);